import { Headline2 } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import styled, { css } from 'styled-components'

const Container = styled.div<{
    backgroundColor: string
    borderRadius?: string
    fullWidth?: boolean
    mobileBorderRadius?: string
    noVerticalPadding?: boolean
}>`
    height: calc(100%-125px);
    background: ${({ backgroundColor }) => backgroundColor};
    overflow: hidden;
    .section-stack {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 30px;
    }
    .section-title {
        padding: 0 20% !important;
        font-family: var(--font-inter);
        font-weight: 650;
        font-size: 36px;
        line-height: 44px;
        letter-spacing: -0.8px;
        span {
            font-family: var(--font-inter);
            font-size: inherit;
            font-weight: 650 !important;
            line-height: inherit;
            letter-spacing: inherit;
            display: inline-block;
            color: ${theme.colors.accentBlueBase};
        }
        @media (max-width: 860px) {
            padding: 0 10% !important;
            font-size: 23px;
            line-height: 28px;
            letter-spacing: -0.2px;
        }
    }

    .section-container {
        width: 100%;
        max-width: 1440px;
        margin: 0 auto;
        padding: ${({ noVerticalPadding }) => (noVerticalPadding ? '48px 0px 48px 0px' : '48px')};
        @media (max-width: 860px) {
            width: 100%;
            padding: ${({ noVerticalPadding }) => (noVerticalPadding ? '48px 0px 48px 0px' : '48px 16px 24px 16px')};
        }
    }
    .section-stack {
        ${({ fullWidth }) =>
            fullWidth &&
            css`
                width: 100%;
                max-width: 100%;
            `}
    }
    border-radius: ${({ borderRadius }) => borderRadius || '0px'};
    @media (max-width: 740px) {
        border-radius: ${({ mobileBorderRadius, borderRadius }) => mobileBorderRadius || borderRadius || '0px'};
    }
`

interface Props {
    backgroundColor: string
    title: string | JSX.Element
    children: JSX.Element
    borderRadius?: string
    fullWidth?: boolean
    mobileBorderRadius?: string
    noVerticalPadding?: boolean
}

const SectionContainer = ({
    backgroundColor,
    title,
    children,
    borderRadius,
    fullWidth,
    mobileBorderRadius,
    noVerticalPadding,
}: Props) => {
    return (
        <Container
            backgroundColor={backgroundColor}
            borderRadius={borderRadius}
            fullWidth={fullWidth}
            mobileBorderRadius={mobileBorderRadius}
            noVerticalPadding={noVerticalPadding}
        >
            <div className="section-container">
                <div className="section-stack">
                    {title && (
                        <Headline2
                            textAlign="center"
                            color={theme.colors.white}
                            fontSize={30}
                            fontFamily="var(--font-inter)"
                            fontWeight={650}
                            className="section-title"
                        >
                            {title}
                        </Headline2>
                    )}
                    {children}
                </div>
            </div>
        </Container>
    )
}

export default SectionContainer
